var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 20",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.49 19.547L24.565.473h4.915l-3.075 19.074H21.49M44.233.94c-.972-.382-2.5-.8-4.404-.8-4.86 0-8.28 2.589-8.308 6.295-.031 2.742 2.44 4.271 4.304 5.182 1.915.935 2.559 1.532 2.551 2.368-.013 1.277-1.529 1.862-2.942 1.862-1.967 0-3.013-.288-4.63-1l-.631-.304-.688 4.27c1.146.531 3.27.992 5.476 1.017 5.164 0 8.52-2.558 8.559-6.516.018-2.174-1.292-3.822-4.128-5.182-1.718-.885-2.772-1.47-2.76-2.366.001-.792.89-1.641 2.816-1.641a8.62 8.62 0 013.678.733l.441.218.666-4.135m6.544 11.843c.408-1.096 1.958-5.331 1.958-5.331-.028.05.405-1.105.653-1.82l.332 1.645s.943 4.553 1.138 5.506h-4.08zM56.841.492h-3.799c-1.178 0-2.06.338-2.576 1.581l-7.299 17.48h5.163s.842-2.351 1.033-2.867c.563 0 5.58.01 6.295.01.147.665.599 2.858.599 2.858h4.561L56.841.492zM17.367.489l-4.81 13.004-.516-2.644c-.897-3.045-3.687-6.346-6.808-8l4.4 16.681 5.202-.003L22.575.489h-5.208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09.476H.166L.1.87c6.167 1.58 10.247 5.394 11.94 9.978l-1.72-8.763C10.02.876 9.158.518 8.09.475"
  }))));
}

var MemoSvgVisa = /*#__PURE__*/React.memo(SvgVisa);
export default MemoSvgVisa;